import {config, request, objectSerial} from 'Utils';

// 列表
export function fetchList(param) {
    return request(`${config.server}/api/v1/dms/trans/transport/listByPage`, {
        method: 'post',
        body: param
    });
}

// 列表（去重）
export function fetchListSingle(param) {
    return request(`${config.server}/api/v1/dms/trans/transport/listGroupByPage`, {
        method: 'post',
        body: param
    });
}

/* 入库保存(按出库单保存)
	 param [
		transportOrder // 出库单号
    substorageid // 子库存id
    isAddStore // 是否添加子库存
	 ]
*/
export function inputStorages(param) {
    return request(`${config.server}/api/v1/dms/trans/transport/inputStorageByTransOrder`, {
        method: 'post',
        body: param
    });
}

/*入库保存
	 param [
		id // 出库单Id
    substorageid // 子库存id
    isAddStore // 是否添加子库存
	 ]
*/
export function inputStorage(param) {
    return request(`${config.server}/api/v1/dms/trans/transport/inputStorage`, {
        method: 'post',
        body: param
    });
}

// 子库存列表
export function fetchSubStoreList(param) {
    return request(`${config.server}/api/v1/dms/dmsTianSubStore/listByPage`, {
        method: 'post',
        body: param
    });
}

// 购货单位列表
export function getGdList(param) {
    return request(`${config.server}/api/v1/dms/dmsPurchase/list`, {
        method: 'post',
        body: param
    });
}

export function syncDelivery(param) {
    return request(`${config.server}/api/v1/dms/trans/transport/syncDelivery?delivery=${param}`, {
        method: 'post',
    });
}


// WEBPACK FOOTER //
// ./src/service/receiving/index.js